export default function Price({value, currency = '€'}) {
  const price = parseFloat(value).toFixed(2)
  return <>{price}&nbsp;{currency}</>
}
